import i18n from './i18n';
import vuetify from './vuetify';
import pinia, { loadConfig } from './pinia';
import router from '../router';
import type { App } from 'vue';

const registerPlugins = async (app: App) => {
  app.use(pinia);

  await loadConfig();
  app.use(vuetify);
  app.use(i18n);
  app.use(router);
};

export default registerPlugins;
